import { WizardStepPage } from '../WizardStepPage/view';

import { DeviceNameStepView } from '../DeviceNameStepView/view';
import { GatewayMessageStepView } from './GatewayMessageStepView/view';

export const GatewayTypeStepView = WizardStepPage.extend({
    template: '#tpl_gateway_type_step',
    stepNumberKey: 'mobile_sensors_wizard_step_one',
    stepTitleKey: 'mobile_sensors_select_gateway_type',
    nextStepViewClass: GatewayMessageStepView,

    templateHelpers: function () {
        return {
            ...GatewayTypeStepView.__super__.templateHelpers.apply(this, arguments),
            image_filename: 'gateway_plug.svg'
        };
    },

    events: {
        'click .next_step': 'displayNextStep'
    },

    displayNextStep: function () {
        const selectedManufacturer = this.$el.find('input[name=gateway_type]:checked').val();
        const isGateway = !this.isSensorModel();

        if (isGateway) {
            if (selectedManufacturer === $f.mobile.sensors.util.MANUFACTURER.MONNIT) {
                return $f.mobile.nav.show(GatewayMessageStepView, {
                    model: this.model,
                    stepNumberKey: this.nextStepNumberKey,
                    selectedManufacturer: $f.mobile.sensors.util.MANUFACTURER.MONNIT
                });
            }

            return $f.mobile.nav.show(DeviceNameStepView, {
                model: this.model,
                stepNumberKey: this.nextStepNumberKey,
                selectedManufacturer: $f.mobile.sensors.util.INTEGRATION_TYPE[selectedManufacturer.toUpperCase()]
            });
        } else {
            return $f.mobile.nav.show(this.nextStepViewClass, {
                model: this.model,
                stepNumberKey: this.nextStepNumberKey,
                selectedManufacturer: selectedManufacturer
            });
        }
    }
});
